import { Action } from '@reduxjs/toolkit';
import signalR$ from '@tpn/redux-observable-signalr-core';
import { combineEpics, StateObservable } from 'redux-observable';
import { merge, Observable, ObservableInput, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PricePrgDependencies, RootState } from '.';
import pricePrgSignalrEpics from '../../src/common/signalr/signalrEpics';
import activityLogEpics from '../features/activitylog/redux/activityLogEpics';
import agreementEpics from '../features/agreement/redux/agreementEpics';
import basePriceEpics from '../features/baseprice/redux/basePriceEpics';
import calculationEpics from '../features/calculation/redux/calculationEpics';
import contactEpics from '../features/contacts/redux/contactEpics';
import customerEpics from '../features/customer/redux/customerEpics';
import customerGroupEpics from '../features/customergroups/redux/customerGroupEpics';
import externalPriceEpics from '../features/externalprice/redux/externalPriceEpics';
import externalPricelistEpics from '../features/externalpricelist/redux/externalPricelistEpics';
import inactivatePriceEpics from '../features/inactivateprices/redux/inactivatePricesEpics';
import priceEpics from '../features/price/redux/priceEpics';
import pricelistEpics from '../features/pricelist/redux/pricelistEpics';
import productEpics from '../features/product/redux/productEpics';
import settingsEpics from '../features/settings/redux/settingsEpics';
import stockEpics from '../features/stock/redux/stockEpics';
import uiEpics from '../features/ui/redux/uiEpics';
import { pricePrgError } from '../features/ui/redux/uiSlices';
import userEpics from '../features/user/redux/userEpics';
import userGroupEpics from '../features/usergroup/redux/userGroupEpics';
import tagEpics from '../features/tags/redux/tagEpics';
import exchangeRateEpics from '../features/exchangerates/redux/exchangeRateEpics';

export default (action$: Observable<Action>, store$: StateObservable<RootState>, dependencies: PricePrgDependencies) =>
    combineEpics(
        ...priceEpics,
        ...pricelistEpics,
        ...customerEpics,
        ...calculationEpics,
        ...productEpics,
        ...pricePrgSignalrEpics,
        ...basePriceEpics,
        ...stockEpics,
        ...uiEpics,
        ...userEpics,
        ...Object.values(userGroupEpics),
        ...externalPricelistEpics,
        ...externalPriceEpics,
        ...agreementEpics,
        ...settingsEpics,
        ...customerGroupEpics,
        ...inactivatePriceEpics,
        ...activityLogEpics,
        ...contactEpics,
        ...tagEpics,
        ...exchangeRateEpics,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(signalR$ as any)
    )(action$, store$, dependencies).pipe(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        catchError<Action, ObservableInput<any>>((error, source) => {
            return merge(of(pricePrgError(error)), source);
        })
    );
